import { Loader, LoaderProps } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';

const LoaderStyles = styled.div<{ darkMode?: boolean }>`
  .MuiCircularProgress-root {
    color: ${({ theme }) => theme.loaderColor};
  }
`;

interface IProps extends LoaderProps {
  style?: React.CSSProperties;
}

const LDLoader: React.FC<IProps> = (props) => {
  const { style, ...rest } = props;
  return (
    <LoaderStyles style={props.style}>
      <Loader {...rest} />
    </LoaderStyles>
  );
};

export default LDLoader;
